import React from "react"
import ContentLoader from "react-content-loader"
import PropTypes from "prop-types"

const TooltipLoader = height => {
  const styleContent = {
    width: "100%",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }

  return (
    <div style={{ margin: "5px 0" }}>
      <ContentLoader
        speed={1}
        backgroundColor="#ffffff"
        foregroundColor="#ededed"
        style={styleContent}
      >
        <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
      </ContentLoader>
    </div>
  )
}

TooltipLoader.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

TooltipLoader.defaultProps = {
  height: "100%",
}

export default TooltipLoader
